.form {
	@apply yst-space-y-4 yst-mt-6;
}
